import { Fragment, type ReactNode } from 'react';
import { StyleSheet, View, type ViewProps } from 'react-native';

import { listStyles } from './shared-styles';
import type { ListItemType } from './types';

export type ListItemGroupProps = ViewProps & {
  header?: ReactNode;
  items: Array<{ id?: string; render: (props: ListItemType) => ReactNode }>;
  footer?: ReactNode;
  borderless?: boolean;
  listItemProps?: Pick<ListItemType, 'minHeightStyle' | 'titleFontWeight'>;
};

export function ListItemGroup({
  header,
  footer,
  items = [],
  borderless,
  listItemProps,
  ...viewProps
}: ListItemGroupProps) {
  const hasHeader = Boolean(header);
  const hasFooter = Boolean(footer);

  return (
    <View
      {...viewProps}
      style={[listStyles.list, borderless && listStyles.listBorderless, viewProps.style]}
    >
      {hasHeader && <View style={styles.header}>{header}</View>}
      {items.map((listItem, index) => (
        <Fragment key={listItem.id ?? index}>
          {listItem.render({
            ...listItemProps,
            isFirstItem: !hasHeader && index === 0,
            isLastItem: !hasFooter && index === items.length - 1,
          })}
        </Fragment>
      ))}
      {hasFooter && <View style={styles.footer}>{footer}</View>}
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    padding: 16,
  },
  footer: {
    padding: 16,
  },
});
